const toolsRoute = {
	name: 'tools',
	path: 'tools',
	redirect: 'tools/list',
	meta: {
		title: 'Herramientas',
	},
	component: () => import('@/pages/configuration/page-tools'),
	children: [
		{
			name: 'tools-list',
			path: 'list',
			meta: {
				title: 'Listado de herramientas',
			},
			components: {
				toolList: () => import('@/pages/configuration/page-tools-list'),
			},
			children: [
				{
					name: 'development-plan-by-competence',
					path: 'development-plan/:nodeId/:toolCode?/:toolId?',
					meta: {
						title: 'Plan de Desarrollo por Competencia',
					},
					components: {
						toolList: () => import('@/pages/configuration/page-development-plan-by-competence'),
					},
				},
				{
					name: 'levels-tool',
					path: ':toolCode/:toolId/levels',
					meta: {
						title: 'Niveles',
					},
					components: {
						toolType: () => import('@/pages/configuration/page-tool-levels'),
					},
					children: [
						{
							name: 'new-type-form',
							path: 'new-type',
							components: {
								newType: () => import('@/components/configuration/tools/new-type-form'),
							},
						},
						{
							name: 'new-level-form',
							path: 'new-level/:number/:hierarchyFatherId?/:id?/:name?/:flagQuestion?',
							components: {
								newLevel: () => import('@/components/configuration/tools/new-level-form'),
							},
							props: true,
						},
					],
				},
				{
					name: 'new-tool',
					path: 'new',
					meta: {
						title: 'Nueva Herramienta',
					},
					components: {
						newToolForm: () => import('@/components/configuration/tools/new-tool-form'),
					},
					children: [
						{
							name: 'tool-type',
							path: 'type',
							meta: {
								title: 'Tipo de herramienta',
							},
							components: {
								toolType: () => import('@/pages/configuration/tool-type-modal'),
							},
						},
						{
							name: 'tool-icons',
							path: 'icons/:type',
							meta: {
								title: 'Seleccionar ícono',
							},
							components: {
								toolIcons: () => import('@/components/shared/icons/icon-modal'),
							},
						},
						{
							name: 'answer-selection',
							path: 'answer-selection',
							meta: {
								title: 'Tipo de respuesta',
							},
							components: {
								answerSelection: () => import('@/components/configuration/tools/answer-type-selection'),
							},
						},
					],
				},
				{
					name: 'edit-tool',
					path: 'edit/:code',
					meta: {
						title: 'Edición de Herramienta',
					},
					components: {
						newToolForm: () => import('@/components/configuration/tools/new-tool-form'),
					},
					children: [
						{
							name: 'tool-type',
							path: 'type',
							meta: {
								title: 'Tipo de herramienta',
							},
							components: {
								toolType: () => import('@/pages/configuration/tool-type-modal'),
							},
						},
						{
							name: 'tool-icons',
							path: 'icons/:type',
							meta: {
								title: 'Seleccionar ícono',
							},
							components: {
								toolIcons: () => import('@/components/shared/icons/icon-modal'),
							},
						},
						{
							name: 'answer-selection',
							path: 'answer-selection',
							meta: {
								title: 'Tipo de respuesta',
							},
							components: {
								answerSelection: () => import('@/components/configuration/tools/answer-type-selection'),
							},
						},
					],
				},
			],
		},
	],
};

export default toolsRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/tools/index.js